import { Space, Text } from '@procurify/ui'

import { VendorLogoBadgeLayoutStyled } from './styles/VendorLogoBadgeLayoutStyled'
import { VendorLogoBadgeMarkStyled } from './styles/VendorLogoBadgeMarkStyled'
import { type ConversationVendor } from '../../value-objects/ConversationTurnItem'

export const VendorLogoBadgeMarkHeights = {
  COMPACT: 15.4,
  DEFAULT: 20,
} as const

export type VendorLogoBadgeMarkHeight =
  (typeof VendorLogoBadgeMarkHeights)[keyof typeof VendorLogoBadgeMarkHeights]

export interface IVendorLogoBadgeProps {
  vendor: ConversationVendor
  markHeight?: VendorLogoBadgeMarkHeight
}

export const VendorLogoBadge = ({
  vendor,
  markHeight = VendorLogoBadgeMarkHeights.COMPACT,
}: IVendorLogoBadgeProps) => (
  <VendorLogoBadgeLayoutStyled>
    <Space direction='horizontal' size='xsmall' align='center'>
      {vendor.logoUrl ? (
        <VendorLogoBadgeMarkStyled
          src={vendor.logoUrl}
          alt={vendor.name}
          $height={markHeight}
        />
      ) : (
        <Text inline bold>
          {vendor.name}
        </Text>
      )}
    </Space>
  </VendorLogoBadgeLayoutStyled>
)
